// removed by extract-text-webpack-plugin
module.exports = {"container":"row__container___DQpwc","head":"row__head___3gd57","data":"row__data___1_eNq"};


//////////////////
// WEBPACK FOOTER
// ./components/Row/row.css
// module id = 273
// module chunks = 0